import { getTeams } from '@maia/shared';
import { http, HttpResponse } from 'msw';

function baseResponse<T>(response: T, page = 1, limit = 10) {
  return {
    statusCode: 200,
    response,
    success: true,
    error: null,
    pagination: {
      page_number: page,
      page_size: limit,
      total_results: 110,
      total_pages: 11,
    },
  };
}

export const handlers = [
  http.get('http://localhost:3000/teams', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const teams = getTeams(limit);
    return HttpResponse.json(baseResponse(teams));
  }),
];
